import script from "./ComexDrilldownLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ComexDrilldownLayout.vue?vue&type=script&setup=true&lang=js"

import "./ComexDrilldownLayout.vue?vue&type=style&index=0&id=193c133a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-193c133a"]])

export default __exports__